import { render } from "./ViewsAuthLogin.vue?vue&type=template&id=0def8916"
import script from "./ViewsAuthLogin.vue?vue&type=script&lang=js"
export * from "./ViewsAuthLogin.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__